/**
 * Time Clock PWA (timeclock.<domain>, /pwa/timeclock): the restaurant's shared clock.
 * The device signs in to the restaurant account (components/pwa); each employee then finds
 * their name (or phone) and enters their staff PIN to clock in / take a break / clock out.
 *
 * The v2 screens (ClockPage, HistoryPage, TimeclockContext) were rebuilt Oct 29 2026 on THE
 * time clock (labor-service /api/timeclock/v2 -> time_clock_entries, the rows Payroll pays),
 * with the offline punch queue (lib/timeclock/punchQueue). They used to punch the signed-in
 * ACCOUNT into a second clock Payroll never read, and every punch answered 500.
 */

import React from 'react';
import { Routes, Route, Navigate, useNavigate } from 'react-router-dom';
import { pwaPath } from '@/utils/getBasePath';
import { Clock } from 'lucide-react';
import { PwaAccountGate, PwaAccountCard } from '@/components/pwa/PwaAccountGate';
import { accountHeaders } from '@/lib/pwaAccount';
import { TimeclockProvider } from './context/TimeclockContext';
import ClockPage from './pages/ClockPage';
import HistoryPage from './pages/HistoryPage';

const headers = () => accountHeaders();

function Clock_() {
  const navigate = useNavigate();
  return <ClockPage onHistory={() => navigate(pwaPath('timeclock', 'history'))} />;
}

function History_() {
  const navigate = useNavigate();
  return (
    <HistoryPage
      onBack={() => navigate(pwaPath('timeclock', 'clock'))}
      footer={<PwaAccountCard note="Signing out stops this device from sending punches until the restaurant signs in again." />}
    />
  );
}

export default function TimeclockApp() {
  return (
    <PwaAccountGate appName="Time Clock" icon={Clock} accent="#10b981">
      {(account) => (
        <TimeclockProvider key={`${account.restaurant.id}:${account.signedInAt}`} authHeaders={headers} auth="account">
          <Routes>
            <Route path="clock" element={<Clock_ />} />
            <Route path="history" element={<History_ />} />
            <Route index element={<Navigate to="clock" replace />} />
            <Route path="*" element={<Navigate to={pwaPath('timeclock', 'clock')} replace />} />
          </Routes>
        </TimeclockProvider>
      )}
    </PwaAccountGate>
  );
}
